module.exports = __webpack_public_path__ + "assets/img/news (20).e639ba8e.png";